document.addEventListener('DOMContentLoaded', function() {
  // Get elements
  const countryZoneElement = document.getElementById("country-zone-data");
  const countryZone = countryZoneElement.getAttribute("data-country-zone"); 
  const allowedCountries = countryZone ? countryZone.split(',').map(country => country.trim()) : [];
  
  const statusElement = document.getElementById('country-activation-status');
  const noteElement = document.getElementById('country-activation-note');
  const modal = document.getElementById('country-modal');
  const showModalBtn = document.getElementById('show-country-list');
  const closeModalBtn = document.querySelector('.close-modal');
  const countryListElement = document.getElementById('country-list');
  const searchInput = document.getElementById('country-search');

  // Improved country detection with fallback
  async function detectUserCountry() {
    const APIs = [
      'https://ipapi.co/json/',
      'https://ipwho.is/',
      'https://freeipapi.com/api/json'
    ];
    
    for (const apiUrl of APIs) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);
        
        const response = await fetch(apiUrl, {
          signal: controller.signal,
          headers: {
            'Accept': 'application/json'
          }
        });
        
        clearTimeout(timeoutId);
        
        if (!response.ok) continue;
        
        const data = await response.json();
        return data.country_name || data.country;
        
      } catch (error) {
        console.log(`Failed with ${apiUrl}, trying next...`, error);
        continue;
      }
    }
    
    console.error("All country detection APIs failed");
    return null;
  }

  // Update UI based on country
  async function updateCountryStatus() {
    try {
      const userCountry = await detectUserCountry();
      const isSupported = userCountry && allowedCountries.includes(userCountry);

      if (isSupported) {
        statusElement.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_true_140x140_bc184139-b4f2-46f4-944d-2b64e25121cd.webp?v=1743585774" height=25px width=25px alt="Valid">
          <span class="valid-country">Global (${userCountry})</span>
        `;
        noteElement.textContent = `Kann in ${userCountry} aktiviert werden.`;
      } else {
        statusElement.innerHTML = `
          <img src="https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_false_140x140_17a67bf5-7271-46bb-84df-74753aca0c9d.webp?v=1743607801" height=20px width=20px alt="Invalid">
          <span class="invalid-country">Not available in your Kann in ${userCountry} aktiviert werden.region</span>
        `;
        noteElement.textContent = userCountry 
          ? `This product is not available in ${userCountry}.` 
          : "View list of available regions below.";
      }
    } catch (error) {
      console.error("Error updating country status:", error);
      statusElement.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_false_140x140_17a67bf5-7271-46bb-84df-74753aca0c9d.webp?v=1743607801" height=20px width=20px alt="Error">
        <span class="invalid-country">Region check unavailable</span>
      `;
      noteElement.textContent = "View list of available regions below.";
    }
  }

  // Populate country list modal
  function populateCountryList() {
    countryListElement.innerHTML = allowedCountries
      .map(country => `<li>${country}</li>`)
      .join('');
  }

  // Search functionality
  function setupSearch() {
    searchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase();
      const countries = countryListElement.querySelectorAll('li');
      
      countries.forEach(country => {
        const countryName = country.textContent.toLowerCase();
        country.style.display = countryName.includes(searchTerm) ? 'block' : 'none';
      });
    });
  }

  // Modal controls
  showModalBtn.addEventListener('click', (e) => {
    e.preventDefault();
    modal.style.display = 'block';
  });

  showModalBtn.addEventListener('touchstart', (e) => {
    e.preventDefault();
    modal.style.display = 'block';
  }, { passive: true });

  closeModalBtn.addEventListener('click', () => {
    modal.style.display = 'none';
  });

  closeModalBtn.addEventListener('touchstart', () => {
    modal.style.display = 'none';
  }, { passive: true });

  window.addEventListener('click', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  });

  window.addEventListener('touchstart', (e) => {
    if (e.target === modal) {
      modal.style.display = 'none';
    }
  }, { passive: true });

  // Initialize with delay to ensure elements exist
  setTimeout(() => {
    updateCountryStatus();
    populateCountryList();
    setupSearch();
    positionCountryZoneForMobile();
  }, 300);

  // Re-position on resize with debounce
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(positionCountryZoneForMobile, 250);
  });
});





// MOBILE -------------------------------------------------------------------------

document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile (≤768px)
  if (!window.matchMedia("(max-width: 768px)").matches) return;

  // Mobile elements
  const mobDataElement = document.getElementById("mob-country-data");
  const mobStatusIcon = document.getElementById("mob-country-status-icon");
  const mobStatusText = document.getElementById("mob-country-status-text");
  const mobNoteText = document.getElementById("mob-country-note");
  const mobShowBtn = document.getElementById("mob-show-country-btn");
  const mobModal = document.getElementById("mob-country-modal");
  const mobCloseBtn = document.querySelector(".mob-close-modal");
  const mobCountryList = document.getElementById("mob-country-list");
  const mobSearchInput = document.getElementById("mob-country-search");

  // Get country data
  const allowedCountries = mobDataElement 
    ? mobDataElement.getAttribute("data-allowed-countries").split(',').map(c => c.trim())
    : [];

  // ===== RELIABLE TOUCH HANDLING =====
  let touchStartTime = 0;
  let touchMoved = false;

  // Handle touch start
  mobShowBtn.addEventListener('touchstart', (e) => {
    touchStartTime = Date.now();
    touchMoved = false;
    e.preventDefault();
  }, { passive: false });

  // Handle touch move (cancel if user scrolls)
  mobShowBtn.addEventListener('touchmove', () => {
    touchMoved = true;
  }, { passive: true });

  // Handle touch end (main click action)
  mobShowBtn.addEventListener('touchend', (e) => {
    const touchDuration = Date.now() - touchStartTime;
    if (!touchMoved && touchDuration < 500) { // Only if tap < 500ms
      e.preventDefault();
      toggleModal();
    }
  }, { passive: false });

  // Click event as fallback
  mobShowBtn.addEventListener('click', (e) => {
    e.preventDefault();
    toggleModal();
  });

  // Modal toggle function
  function toggleModal() {
    const isOpening = mobModal.style.display !== 'block';
    mobModal.style.display = isOpening ? 'block' : 'none';
    document.body.style.overflow = isOpening ? 'hidden' : '';
    
    if (isOpening) {
      // Focus search input after slight delay
      setTimeout(() => mobSearchInput.focus(), 100);
    }
  }

  // Close handlers
  mobCloseBtn.addEventListener('touchend', (e) => {
    e.preventDefault();
    toggleModal();
  }, { passive: false });

  mobCloseBtn.addEventListener('click', () => {
    toggleModal();
  });

  // Close when tapping outside modal
  mobModal.addEventListener('touchend', (e) => {
    if (e.target === mobModal) {
      e.preventDefault();
      toggleModal();
    }
  }, { passive: false });

  // ===== COUNTRY DETECTION =====
  async function detectMobCountry() {
    const APIs = [
      'https://ipapi.co/json/',
      'https://ipwho.is/',
      'https://freeipapi.com/api/json'
    ];
    
    for (const apiUrl of APIs) {
      try {
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 3000);
        
        const response = await fetch(apiUrl, {
          signal: controller.signal,
          headers: { 'Accept': 'application/json' }
        });
        
        clearTimeout(timeoutId);
        
        if (!response.ok) continue;
        
        const data = await response.json();
        return data.country_name || data.country;
        
      } catch (error) {
        console.log(`Failed with ${apiUrl}, trying next...`, error);
        continue;
      }
    }
    
    console.error("All country detection APIs failed");
    return null;
  }

  // ===== UI UPDATE =====
  async function updateMobUI() {
    try {
      mobStatusText.textContent = "Detecting your region...";
      mobNoteText.textContent = "";
      
      const userCountry = await detectMobCountry();
      const isSupported = userCountry && allowedCountries.includes(userCountry);

      if (isSupported) {
        mobStatusIcon.src = "https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_true_140x140_bc184139-b4f2-46f4-944d-2b64e25121cd.webp?v=1743585774";
        mobStatusText.textContent = `Global (${userCountry})`;
        mobStatusText.className = "mob-status-text mob-status-valid";
        mobNoteText.textContent = `Kann in ${userCountry} aktiviert werden.`;
      } else {
        mobStatusIcon.src = "https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_false_140x140_17a67bf5-7271-46bb-84df-74753aca0c9d.webp?v=1743607801";
        mobStatusText.textContent = "Not available in your region";
        mobStatusText.className = "mob-status-text mob-status-invalid";
        mobNoteText.textContent = userCountry 
          ? `This product is not available in ${userCountry}.` 
          : "View list of available regions below.";
      }
    } catch (error) {
      console.error("Error updating country status:", error);
      mobStatusIcon.src = "https://cdn.shopify.com/s/files/1/0875/5272/1227/files/language_false_140x140_17a67bf5-7271-46bb-84df-74753aca0c9d.webp?v=1743607801";
      mobStatusText.textContent = "Region check unavailable";
      mobStatusText.className = "mob-status-text mob-status-invalid";
      mobNoteText.textContent = "View list of available regions below.";
    }
  }

  // ===== COUNTRY LIST =====
  function populateMobCountryList() {
    mobCountryList.innerHTML = allowedCountries
      .map(country => `<li>${country}</li>`)
      .join('');
  }

  function setupMobSearch() {
    mobSearchInput.addEventListener('input', function() {
      const searchTerm = this.value.toLowerCase();
      const countries = mobCountryList.querySelectorAll('li');
      
      countries.forEach(country => {
        country.style.display = country.textContent.toLowerCase().includes(searchTerm) 
          ? 'block' 
          : 'none';
      });
    });
  }

  // ===== INITIALIZATION =====
  function initialize() {

    // Set up components
    populateMobCountryList();
    setupMobSearch();
    updateMobUI();
  }

  // Start with slight delay
  setTimeout(initialize, 100);
  
  // Re-run on resize
  window.addEventListener('resize', () => {
    if (window.matchMedia("(max-width: 768px)").matches) {
      initialize();
    }
  });
});